<template>
  <div class="login d-flex column_sp">
    <section class="box_2column">
      <h2>ご利用登録をされている方</h2>
      <p class=""><span class="alert_txt">会員番号</span>、パスワードをご入力ください。</p>
      <div class="">
        <div class="box-p-20">
          <div>
            <label class="alert_txt">会員番号</label><br />
            <input
              type="number"
              id="txtAddress"
              name="txtAddress"
              class="w-100"
              v-model="no"
            />
            <p class="alert_txt" v-show="errors.no != ''">{{ errors.no }}</p>
          </div>
          <div class="my-3">
            <label>パスワード</label><br />
            <input
              type="password"
              id="txtPass"
              name="txtPass"
              class=""
              v-model="passwd"
            />
            <p class="alert_txt" v-show="errors.passwd != ''">{{ errors.passwd }}</p>
          </div>
          <input
            id="chkSave"
            type="checkbox"
            class="LargCheckBox"
            v-model="omit"
          />
          <label for="chkSave"
            >次回から会員番号・パスワードの入力を省略する</label
          >
        </div>
        <div class="box-p-20 w-100 text-center my-5">
          <!-- 本番のログインボタン -->
          <button type="submit" id="objBtn" name="objBtn" @click="login">
            ログインする
          </button>
        </div>
      </div>
      <p>
        ※会員番号・パスワードをお忘れの場合は、会員課へお問合せください。<br>(電話番号：0120-268-510)
      </p>
    </section>
    <section class="box_2column">
      <h2>ご利用登録がまだの方</h2>
      <p class="">
        ログインには会員サイトで使用するパスワードの登録が必要になります。以下よりご登録をお願い致します。
      </p>
      <div class="box-p-20 text-center my-5">
        <router-link to="/register" class="btn">ご利用登録</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import Authenticate from "@/modules/Authenticate";
import Request from "@/modules/Request";
import Message from "@/modules/Message";

let auth = new Authenticate();
let request = new Request();

export default {
  data() {
    // 保存していたemail, passwordを呼び出す
    let loginInfo = auth.getLoginInfo();
    return {
      no: loginInfo.no,
      passwd: loginInfo.passwd,
      omit: loginInfo.omit,
      errors: {
        no: "",
        passwd: "",
      },
    };
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {
    login() {
      this.errors.no = "";
      this.errors.passwd = "";
      if (this.no == "") {
        console.log('error')
        this.errors.no = "会員番号を入力してください";
      }
      if (this.passwd == "") {
        this.errors.passwd = "パスワードを入力してください";
      }

      if (this.errors.no != "" || this.errors.passwd != "") {
        return false;
      }

      let postParmas = [this.no, this.passwd];
      let requestParams = request.createParams(
        "webMdlLogin",
        "putLoginByMemberNo",
        postParmas
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status && data.status == "good") {
            // ログイン情報を保存するかどうか
            if (this.omit) {
              auth.setLoginInfo(this.no, this.passwd, this.omit);
            } else {
              auth.clearLoginInfo();
            }
            auth.login(data.uid, data.Member, data.Shopping);
          } else {
            let msg = data.msg.split("\t");
            if (msg.length > 1) {
              Message.error().fire({
                title: "ログインに失敗しました",
                text: msg[1],
              });
            } else {
              Message.error().fire({
                title: "ログインに失敗しました",
                text: data.msg,
              });
            }
          }
        });
    },
  },
};
</script>


